import { AdventureRewardType, ADVENTURE_REWARD_ICONS } from "../adventure/adventure_box_rewards.js";

export type DailyChallengeRewardType = AdventureRewardType;

export interface DailyChallengeReward
{
  type: DailyChallengeRewardType;
  amount: number;
}

export const DAILY_CHALLENGE_REWARD_ICONS = ADVENTURE_REWARD_ICONS;

export const DAILY_CHALLENGE_REWARDS: Record<number, DailyChallengeReward[]> = {
  1: [
    { type: "coin", amount: 10 },
  ],
  2: [
    { type: "coin", amount: 15 },
    { type: "heart", amount: 1 },
  ],
  3: [
    { type: "multiballs", amount: 1 },
  ],
  4: [
    { type: "coin", amount: 25 },
    { type: "fireworks", amount: 1 },
  ],
  5: [
    { type: "coin", amount: 50 },
    { type: "fireworks", amount: 2 },
    { type: "multiballs", amount: 1 },
    { type: "big_balls", amount: 1 },
    { type: "infinite_balls", amount: 1 },
  ],
};

export function getDailyChallengeRewards( day: number ): DailyChallengeReward[]
{
  return DAILY_CHALLENGE_REWARDS[ day ] ?? [];
}
